export default class OntosError extends Error {
    constructor(message: string, cause?: Error) {
        super(message)
        this.name = 'OntosError'
        if (cause) console.error(cause)
    }
}
